import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { createElement } from 'services/checklistEndPoints';
import { ICreateElement } from 'interfaces/requirements.interface';

export const createChecklistElement = createAsyncThunk(
  'checklist/createElement',
  async (data: ICreateElement) => {
    try {
      const endpoint = createElement(data);
      return await apiFetch<Partial<ICreateElement>>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('create Element catch:', message);
      throw Error(message);
    }
  }
);
